import React, { useState, useEffect } from 'react';
import * as Utils from '../../utils';
import tooltip from '../../themes/tooltip';
import TooltipView from './TooltipView';
const tooltipGenerator = (tooltipKey) => ({ direction, text, children, lang = 'en', positionLeft = tooltip.directions[direction].tooltipLeft, positionRight = tooltip.directions[direction].tooltipRight, positionTransform = tooltip.directions[direction].tooltipTransform, triggerType = 'hover', overlay, isArrowHide = false, delay = 0, e2eTooltipId, e2eContentId, }) => {
    const [isShow, setIsShow] = useState(false);
    const hideTooltip = () => {
        setIsShow(false);
    };
    const timer = new Utils.TimeoutTimer(delay, hideTooltip);
    useEffect(() => {
        timer.stop();
    }, [timer]);
    const onClick = () => {
        if (triggerType === 'click') {
            setIsShow(!isShow);
        }
    };
    const onMouseEnterTips = () => {
        timer.stop();
        setIsShow(true);
    };
    const onMouseLeaveTips = () => {
        hideTooltip();
    };
    const onMouseEnterChildren = () => {
        timer.stop();
        if (triggerType === 'hover') {
            setIsShow(true);
        }
    };
    const onMouseLeaveChildren = () => {
        timer.start();
        hideTooltip();
    };
    return (React.createElement(TooltipView, { lang: lang, type: tooltipKey, text: text, show: isShow, overlay: overlay, isArrowHide: isArrowHide, direction: direction, onClick: onClick, onMouseEnter: onMouseEnterTips, onMouseLeave: onMouseLeaveTips, onMouseEnterChildren: onMouseEnterChildren, onMouseLeaveChildren: onMouseLeaveChildren, positionLeft: positionLeft, positionRight: positionRight, positionTransform: positionTransform, e2eTooltipId: e2eTooltipId, e2eContentId: e2eContentId }, children));
};
export const Primary = tooltipGenerator('primary');
export const Destructive = tooltipGenerator('destructive');
export const Reverse = tooltipGenerator('reverse');
//# sourceMappingURL=Tooltip.js.map